import { Flex, Result } from "antd";

export const LoginFailed = () => {
  return (
    <Flex align="center" justify="center" style={{ height: "100vh" }}>
      <Result
        status="error"
        title="Nemate autorizaciju za pristup sistemu."
        subTitle="Molimo Vas da kontaktirate Ministarstvo finansija."
      />
    </Flex>
  );
};
